// extracted by mini-css-extract-plugin
export default {"container":"Xf","header":"Yf","logodesktop":"Zf","logomobile":"ag","imgcontainer":"bg","slidercontainer":"cg","slick-slider":"eg","slick-initialized":"fg","sliderbox":"gg","headline":"hg","mainheadline":"ig","capitalize":"jg","desc":"kg","descitalic":"lg","desccenter":"mg","descborder":"ng","subdesc":"og","welcomeslide":"pg","desccard":"qg","img":"rg","button":"sg","buttonskip":"tg","customPosition":"ug"};
    if(module.hot) {
      // 1730991505724
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  